import * as THREE from 'three';
import type { LandmarkDef } from './common';
import { landmarkModel } from './model';

/**
 * landmarks/rio.ts — Rio's landmarks. Arcos da Lapa is a drive-through
 * ('span') scaled by width. GS-Rio round: christ_redeemer carries a CC-BY
 * Sketchfab statue scan (see public/models/landmarks/CREDITS.md) whose baked
 * material is named `baked_christ` to MISS the triplanar classifier while the
 * scripted Corcovado under it wears role names — the model.ts path-(b)
 * integration, so NO skipTexturing here. sugarloaf is a Hyper3D-generated
 * twin-dome massif with its own baked granite (`baked_sugarloaf`, same trick).
 */
export const RIO_LANDMARKS: Record<string, LandmarkDef> = {
  sugarloaf: {
    build: () => {
      // The massif's base pad must SINK below the shoreline (the old model's
      // slab floated over the beach). The normaliser pins bbox-min to y=0, so
      // a wrapper group drops the whole model 7 units; height 62 − 7 sunk
      // keeps the old ~55-unit visible silhouette.
      const wrap = new THREE.Group();
      const m = landmarkModel('models/landmarks/sugarloaf.glb', { height: 62 });
      m.position.y = -7;
      wrap.add(m);
      return wrap;
    },
    placement: 'side',
    offset: 95,
  },
  // GS-Rio: the slender white two-tier arcade is 96 native units wide with the
  // central arch's clear half-span at 22/96 of the total — scaling by
  // 2*hw + 60 keeps that opening ≥ the rails (+ margin) at any track width
  // (hw 18 → clear ±22 vs rails ±18; soffit 18.6 high at the rail line).
  arcosDaLapa: { build: (hw) => landmarkModel('models/landmarks/arcos_da_lapa.glb', { width: 2 * hw + 60 }), placement: 'span' },
  christRedeemer: { build: () => landmarkModel('models/landmarks/christ_redeemer.glb', { height: 62 }), placement: 'side', offset: 60 },
  // M97: the bowl is ~59 units in radius — anchored past the COURSE END so its
  // near rim clears the end barrier (it used to wall off the finish line itself).
  maracana: { build: () => landmarkModel('models/landmarks/maracana.glb', { height: 30 }), placement: 'finish', ahead: 78 },
};
